import { initializeApp, FirebaseApp } from 'firebase/app';
import {
  Analytics,
  getAnalytics,
  isSupported,
  logEvent as firebaseLogEvent,
  setUserId as firebaseSetUserId,
  setUserProperties as firebaseSetUserProperties,
} from 'firebase/analytics';

const firebaseConfigProd = {
  apiKey: 'AIzaSyBocOqGwdGHr2Q-UzNntRm3Kx7eQ76aqg8',
  authDomain: 'pontuax-admin-prod.firebaseapp.com',
  databaseURL: 'https://pontuax-admin-prod.firebaseio.com',
  projectId: 'pontuax-admin-prod',
  storageBucket: 'pontuax-admin-prod.appspot.com',
  messagingSenderId: '769733006886',
  appId: '1:769733006886:web:0297205291342d7fa0f8e7',
  measurementId: 'G-XM2Y09HVTD',
};

const firebaseConfigDev = {
  apiKey: 'AIzaSyAMfJZYXLCNDUpvE7XgeQ-j92axyVbnWX0',
  authDomain: 'pontuax-admin-dev.firebaseapp.com',
  databaseURL: 'https://pontuax-admin-dev.firebaseio.com',
  projectId: 'pontuax-admin-dev',
  storageBucket: 'pontuax-admin-dev.appspot.com',
  messagingSenderId: '431514782044',
  appId: '1:431514782044:web:d328bfa5fef6e157825999',
  measurementId: 'G-G5JG523C6M',
};

const isProd = import.meta.env.VITE_ENVIRONMENT === 'production';

export const ENVIRONMENT: 'production' | 'development' = isProd ? 'production' : 'development';

let firebaseApp: FirebaseApp | null = null;
let analyticsInstance: Analytics | null = null;
let initPromise: Promise<Analytics | null> | null = null;

const initialize = async (): Promise<Analytics | null> => {
  if (analyticsInstance) return analyticsInstance;

  try {
    const supported = await isSupported();
    if (!supported) return null;

    if (!firebaseApp) {
      firebaseApp = initializeApp(isProd ? firebaseConfigProd : firebaseConfigDev);
    }
    analyticsInstance = getAnalytics(firebaseApp);
    return analyticsInstance;
  } catch (err) {
    if (!isProd) console.warn('[analytics] init failed', err);
    return null;
  }
};

export const getAnalyticsInstance = (): Promise<Analytics | null> => {
  if (!initPromise) initPromise = initialize();
  return initPromise;
};

export const logEvent = async (name: string, params?: Record<string, unknown>): Promise<void> => {
  const instance = await getAnalyticsInstance();
  if (!instance) return;
  try {
    firebaseLogEvent(instance, name, params as Record<string, unknown>);
  } catch (err) {
    if (!isProd) console.warn('[analytics] logEvent failed', name, err);
  }
};

export const setUserId = async (id: string | null): Promise<void> => {
  const instance = await getAnalyticsInstance();
  if (!instance) return;
  firebaseSetUserId(instance, id ?? '');
};

export const setUserProperties = async (props: Record<string, unknown>): Promise<void> => {
  const instance = await getAnalyticsInstance();
  if (!instance) return;
  firebaseSetUserProperties(instance, props as Record<string, string>);
};
